
export default class ForceEvaluatorUploadToTpInstanceItem 
{
    constructor (evaluator, tpInstanceId) 
    {
        this.Evaluator = evaluator;
        this.TpInstanceId = tpInstanceId;
    }


}
